module.exports = __webpack_public_path__ + "static/media/0011.db06dc98.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/handles/H48104/Decors_colored/G10_white/0011.png
// module id = 2177
// module chunks = 0